module.exports = "export default __webpack_public_path__ + &quot;fd1c0d39fe97a3316ef615b6c4e28750.svg&quot;;"